import { render, staticRenderFns } from "./UnitDetailManage.vue?vue&type=template&id=b03803f0"
import script from "./UnitDetailManage.vue?vue&type=script&lang=js"
export * from "./UnitDetailManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports